import React, { useContext } from "react";
//import "./safetyforms/safetyforms.css";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { newDocument } from "../common/slices/document";
import { BlackButton, ButtonBase } from "./Buttons";
import FormDropZone from "./FormDropZone";
import FormTextArea from "./FormTextArea";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P, P2 } from "./Typography";
import FormCheckbox from "./FormCheckbox";
import { newFolder } from "../common/slices/folder";
import { ErrorContext } from "../ErrorContext";

const ModalNewFolder = ({ onClose, parent }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const {
        control,
        handleSubmit,
        formState: { errors, isValid, isSubmitting },
        watch
    } = useForm({
        defaultValues: {
            id: uuid(),
            parentId: parent?.id,
            name: "",
        }
    });

    const formProps = { control, errors };

    const onSubmit = async (data) => {
        try {
            await dispatch(newFolder(data));
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to create folder", forSupport: ex.message })
        }
    };

    const name = watch('name');

    return (
        <Modal show size="33%">
            <Row>
                <H1>Create new folder</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <FormTextInput name="name" label="Folder name" placeholder="Enter folder name" {...formProps} rules={{ required: true }} containerStyle={{ flex: 1 }} />
            <P>{parent?.parentId !== 'root' ? '../' : ''}{parent?.name}/{name.trim()}</P>
            <BlackButton onClick={handleSubmit(onSubmit)} disabled={!isValid || isSubmitting}>Save</BlackButton>
        </Modal>
    );
};

export default ModalNewFolder;
